import { __awaiter } from "tslib";
import services from '@/services/index';
const namespaced = true;
class State {
    constructor() {
        this.leverages = [];
    }
}
const getters = {
    getLeveragesBody: (state) => state.leverages
};
const actions = {
    loadLeverages({ commit }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield services.mainService.getLeverages(null);
            if (response.success) {
                commit('setLeverages', response.data);
            }
            else {
                commit('mainPageModules/setAllWidgetsError', null, { root: true });
            }
        });
    }
};
const mutations = {
    setLeverages: (state, payload) => { state.leverages = payload; }
};
export default {
    namespaced,
    state: new State(),
    actions,
    getters,
    mutations
};
